var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seciton-information"},[_c('div',{staticClass:"seciton-information__qr-code"},[_c('button',{on:{"click":_vm.handleGenerateCode}},[_vm._v("Generate QR Code")])]),_c('QrCodeModal',{attrs:{"code":_vm.qrCode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }